export default __webpack_public_path__ + "static/media/fighting.8ec17be2.svg";